import PropTypes from 'prop-types'
import React from 'react'
import Edit from '@mui/icons-material/Edit'

const EditIcon = ({ className }) => <Edit className={className} />

export default EditIcon

EditIcon.propTypes = {
  className: PropTypes.string
}
